import ROUTES from '~/shared/constants/routes.const'

const nonRedirectPaths = [
  ROUTES.CAMPAIGNS,
  ROUTES.PARTNER,
  ROUTES.EXCEL,
  ROUTES.GEOGEBRA,
  ROUTES.ENCYCLOPEDIA,
  ROUTES.EXAMS,
  ROUTES.DRILL,
  ROUTES.MATH_VAULT,
  ROUTES.START,
]

export default function shouldRedirectToPlatformLanguage(currentPath: string): boolean {
  // special condition: To avoid getting the bootcamp grade select page in mixed language
  if (
    currentPath === ROUTES.BOOTCAMP ||
    currentPath.startsWith(ROUTES.BOOTCAMP_SELECT_GRADE) ||
    currentPath.startsWith(ROUTES.CAMPAIGNS_ACCENTURE)
  ) {
    return true
  } else if (currentPath.includes('callback')) {
    return false
  }
  return !nonRedirectPaths.some((startPath) => currentPath.startsWith(startPath))
}
